import { Injectable, EventEmitter } from '@angular/core';
import { ConfigService } from '@ngx-config/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';



import { BaseService} from '../services/base.service';
import { Parametrizacao } from 'shared/entities/parametrizacao.entity';



@Injectable()
export class ParametroService extends BaseService  {
    
    
	constructor(private http: HttpClient,  readonly config: ConfigService) {
        super(config)
        this.apiUrl += 'Parametrizacao';             
    }
    
    public Retornar(Identificador: number): Observable<Parametrizacao>
    {
       
        var url: string = this.apiUrl + '/' + Identificador.toString() ;
        return this.http.get<Parametrizacao>(url).pipe(
            map(response => JSON.parse(JSON.stringify(response), this.AjustarDataHora))
        )
    }
 

}